import { useEffect, useState } from "react"
import { Menu, useMenu } from "@/shared/components"
import i18n from "@/shared/config/i18n"
import { defaultLocale, type ILang, LANG_I18KEYS, LANG_OPTIONS, SHORT_LANG } from "@/shared/config/locales.ts"

export const LanguageChangerV2 = () => {
  // State
  const [lang, setLang] = useState<keyof ILang>(defaultLocale)
  // Helpers
  const { menuProps, targetProps, setOpen } = useMenu()

  // Functions
  const handleChange = (value: keyof ILang) => {
    console.log({ value })
    const lang = LANG_OPTIONS.find(lang => lang.value === value)?.value || "ru"
    i18n.changeLanguage(LANG_I18KEYS[value])
    localStorage.setItem("i18nextLng", lang)
    setLang(lang)
    setOpen(false)
  }
  // Set initial language from localStorage or default
  useEffect(() => {
    const storedLang = localStorage.getItem("i18nextLng") as keyof ILang | null
    if (storedLang) {
      setLang(storedLang)
      i18n.changeLanguage(LANG_I18KEYS[storedLang])
    }
  }, [])

  return (
    <div className="absolute top-3 right-3 overflow-hidden rounded-xl border border-border">
      <div {...targetProps}>
        <div className="flex h-11 w-11 cursor-pointer items-center justify-center bg-background">{SHORT_LANG[lang]}</div>
      </div>
      <Menu {...menuProps}>
        {LANG_OPTIONS.map(({ label, value }) => (
          <Menu.Item className="flex justify-center p-2" onClick={() => handleChange(value)} key={value} label={label} />
        ))}
      </Menu>
    </div>
  )
}
